import React, { createContext, useContext } from 'react';
import { appConfig, AppConfig } from '../config/appConfig';

const ConfigContext = createContext<AppConfig>(appConfig);

export const useConfig = () => useContext(ConfigContext);

export const ConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
};
